module.exports = __webpack_public_path__ + "static/media/food_5.695eb91d.jpeg";